import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Document as ContentfulDocument } from '@contentful/rich-text-types';
import { CommonModule } from '@angular/common';
import { RichTextHtmlRendererService } from '@app/shared/services/contentful/rich-text-html-renderer/rich-text-html-renderer.service';

@Component({
  selector: 'rsc-asp-rich-text',
  standalone: true,
  templateUrl: './rich-text.component.html',
  styleUrls: ['./rich-text.component.scss'],
  imports: [CommonModule],
})
export class RichTextComponent implements OnChanges {
  @Input() content: ContentfulDocument | null | undefined = null;

  sanitizedHtml: SafeHtml | null = null;

  constructor(private richTextService: RichTextHtmlRendererService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content'] && this.content) {
      this.renderRichText();
    } else {
      this.sanitizedHtml = null;
    }
  }

  private async renderRichText(): Promise<void> {
    if (this.content) {
      this.sanitizedHtml = await this.richTextService.renderRichText(
        this.content,
      );
    }
  }
}
